module.exports = __webpack_public_path__ + "img/horse-body.b066c58d.jpg";